import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-save',
  templateUrl: './confirm-save.component.html',
  styleUrls: ['./confirm-save.component.scss']
})
export class ConfirmSaveComponent {
  constructor(private dialog:MatDialog){}
  close()
  {
    const okdialog=this.dialog.getDialogById('savedialog')
    okdialog?.close(true)
  }
}
